function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "512",
  height: "100",
  rx: "50",
  ry: "50"
}), /*#__PURE__*/React.createElement("rect", {
  y: "206",
  width: "512",
  height: "100",
  rx: "50",
  ry: "50"
}), /*#__PURE__*/React.createElement("rect", {
  y: "412",
  width: "512",
  height: "100",
  rx: "50",
  ry: "50"
})));